import React from "react"
import { MenuProvider } from "./src/components/MenuContext"
import { AnimatePresence } from "framer-motion"
import "@fontsource/heebo/400.css"
import "@fontsource/heebo/700.css"
import { PlayerProvider } from "./src/components/PlayerContext"
import SoundCloudProvider from "./src/components/SoundCloudProvider"
import PersistentPlayerPortal from "./src/components/PersistentPlayerPortal"

export const onClientEntry = () => {
  if (!document.getElementById("persistent-player-root")) {
    const div = document.createElement("div")
    div.id = "persistent-player-root"
    document.body.appendChild(div)
  }
}

// Create a wrapper that keeps the player outside of page transitions
const PageWrapper = ({ element }) => {
  return (
    <div className="site-wrapper">
      <div id="persistent-elements" className="persistent-elements">
        {/* Elements that should persist across page transitions */}
      </div>
      <div className="page-content">
        <AnimatePresence mode="wait">{element}</AnimatePresence>
      </div>
    </div>
  )
}

export const wrapPageElement = ({ element }) => {
  return <PageWrapper element={element} />
}

export const wrapRootElement = ({ element }) => (
  <MenuProvider>
    <PlayerProvider>
      <SoundCloudProvider>
        <>
          {element}
          <PersistentPlayerPortal />
        </>
      </SoundCloudProvider>
    </PlayerProvider>
  </MenuProvider>
)

// Handle route changes
export const onRouteUpdate = () => {
  // Ensure the player stays mounted and doesn't reload
  const player = document.querySelector("#persistent-player")
  if (player) {
    player.style.display = "block"
  }
}
